export default __webpack_public_path__ + "locales/ko-KR/Files.json?hash=8d2141083acd4c449f9eedc40ddbc42d";